var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty } from '@syncfusion/ej2-base';
/**
 * Configures tooltip settings for Gantt.
 */
export class TooltipSettings extends ChildProperty {
}
__decorate([
    Property(true)
], TooltipSettings.prototype, "showTooltip", void 0);
__decorate([
    Property()
], TooltipSettings.prototype, "taskbar", void 0);
__decorate([
    Property()
], TooltipSettings.prototype, "baseline", void 0);
__decorate([
    Property()
], TooltipSettings.prototype, "connectorLine", void 0);
__decorate([
    Property()
], TooltipSettings.prototype, "editing", void 0);
__decorate([
    Property()
], TooltipSettings.prototype, "timeline", void 0);
